import React, { createContext, useContext, useState } from "react";

// Local capsule row (per-page override buttons)
export const DATE_RANGES = [
	{ key: "30d", label: "30d",      days: 30  },
	{ key: "90d", label: "90d",      days: 90  },
	{ key: "6m",  label: "6 months", days: 182 },
	{ key: "1yr", label: "1 year",   days: 365 },
	{ key: "all", label: "All Time", days: null },
];

// Global dropdown quick presets
export const GLOBAL_PRESETS = [
	{ key: "today", label: "Today",        days: 0  },
	{ key: "7d",    label: "Last 7 Days",  days: 7  },
	{ key: "30d",   label: "Last 30 Days", days: 30 },
	{ key: "90d",   label: "Last 90 Days", days: 90 },
];

const ALL_PRESETS = [...GLOBAL_PRESETS, ...DATE_RANGES];

/** Convert a range key (+ optional custom {from,to}) to { from, to } query params. */
export const rangeToParams = (key, customRange = null) => {
	if (key === "custom") {
		return customRange?.from && customRange?.to
			? { from: customRange.from, to: customRange.to }
			: {};
	}
	if (!key || key === "all") return {};
	const range = ALL_PRESETS.find(r => r.key === key);
	if (!range || range.days == null) return {};
	const to   = new Date();
	const from = new Date(Date.now() - range.days * 86_400_000);
	return {
		from: from.toISOString().slice(0, 10),
		to:   to.toISOString().slice(0, 10),
	};
};

/** Human label for the trigger button / status readouts. */
export const getRangeLabel = (key, customRange = null) => {
	if (key === "custom" && customRange?.from && customRange?.to) {
		const fmt = (d) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" });
		return `${fmt(customRange.from)} – ${fmt(customRange.to)}`;
	}
	return ALL_PRESETS.find(r => r.key === key)?.label ?? "All Time";
};

const DateFilterContext = createContext(null);

export const DateFilterProvider = ({ children }) => {
	const [globalRange,       setGlobalRangeState] = useState("90d");
	const [globalCustomRange, setGlobalCustomRange] = useState(null); // {from, to} ISO strings, only when key === "custom"

	/** Single entry point: pass a preset key, or "custom" + {from,to}. */
	const setGlobalRange = (key, customRange = null) => {
		setGlobalRangeState(key);
		setGlobalCustomRange(key === "custom" ? customRange : null);
	};

	return (
		<DateFilterContext.Provider value={{ globalRange, globalCustomRange, setGlobalRange }}>
			{children}
		</DateFilterContext.Provider>
	);
};

export const useDateFilter = () => useContext(DateFilterContext);
